import React, { useEffect, useState, useRef } from 'react';
import { Carousel, Card, Spin, Button, Empty } from 'antd';
import axios from 'axios';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const URL = process.env.REACT_APP_API_URL;

const ToBeJoinedCandidates = () => {
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(true);
  const carouselRef = useRef(null);

  useEffect(() => {
    const fetchCandidates = async () => {
      try {
        const response = await axios.get(`${URL}/api/getAllCandidates`);
        const filteredCandidates = response.data.reverse()
          .filter(candidate =>
            ['Offered', 'Shortlisted for Offer'].includes(candidate.status)
          )
          .sort((a, b) => new Date(a.joiningDate) - new Date(b.joiningDate))
          .slice(0, 5);
        setCandidates(filteredCandidates);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching to-be-joined candidates:', error);
        setLoading(false);
      }
    };

    fetchCandidates();
  }, []);

  const next = () => {
    carouselRef.current.next();
  };

  const prev = () => {
    carouselRef.current.prev();
  };

  return (
    <div className='hotpicks'>
      <h1 style={{ margin: '10px 20px', fontSize: '20px' }}>To Join Candidates</h1><br />
      {loading ? (
        <Spin size="large" />
      ) : candidates.length ? (
        <div>
          <Button
            type="primary"
            shape="circle"
            icon={<LeftOutlined />}
            onClick={prev}
            style={{ position: 'absolute', top: '50%', left: '0', background: '#00B4D2', transform: 'translateY(-50%)', zIndex: 1 }}
          />
          <Carousel ref={carouselRef} dots={false} slidesToShow={4} slidesToScroll={4} infinite={false}>
            {candidates.map(candidate => (
              <div key={candidate._id}>
                <Card
                  title={<h2>{candidate.fullName}</h2>}
                  className="card-hover"
                  style={{
                    padding: '5px',
                    width: 220,
                    margin: '0px 20px 0px 20px',
                    textTransform: 'capitalize',
                    borderRadius: '1px',
                    boxShadow: '0px 2px 4px rgb(38, 39, 130)',
                  }}
                >
                  <p><strong>Position:</strong> {candidate.position}</p>
                  <p><strong>Experience:</strong> {candidate.relevantExperience} Years</p>
                  <p><strong>Location:</strong> {candidate.location}</p>
                  <p><strong>Joining:</strong> <span style={{ color: 'orange', fontWeight: 'bold' }}>
                    {candidate.joiningDate ? new Date(candidate.joiningDate).toLocaleDateString() : 'TBD'}
                  </span></p>
                </Card>
              </div>
            ))}
          </Carousel>
          <Button
            type="primary"
            shape="circle"
            icon={<RightOutlined />}
            onClick={next}
            style={{ position: 'absolute', top: '50%', right: '0', background: '#00B4D2', transform: 'translateY(-50%)', zIndex: 1 }}
          />
        </div>
      ) : (
        <Empty description="No candidates to join available" />
      )}
    </div>
  );
};

export default ToBeJoinedCandidates;